export const TREATMENT_TYPE_TABLE = 'TABLE';
export const TREATMENT_TYPE_DIAGRAM = 'DIAGRAM';
export const TREATMENT_TYPE_FILLER = 'FILLER';
